import { AudioLinesIcon } from "lucide-react";

import { SadieVoiceCallRow } from "./SadieVoiceCallRow";
import { Column, EmptyState } from "@/components";
import { Table, TableBody, TableHead, TableHeader, TableRow } from "@ui/table";

import { SadieCallResponse } from "@/types";

export const SadieVoiceCallsTable = ({
  calls,
}: {
  calls: SadieCallResponse[];
}) => {
  /* Render */
  if (calls.length === 0) {
    return (
      <EmptyState
        description="Calls to Sadie's line show up here once they end."
        Icon={AudioLinesIcon}
        title="No calls yet"
      />
    );
  }

  return (
    <Column className="overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[180px]">From</TableHead>
            <TableHead className="w-[180px]">Date & Time</TableHead>
            <TableHead className="w-[100px]">Duration</TableHead>
            <TableHead>Playback</TableHead>
            <TableHead className="w-[60px]" />
          </TableRow>
        </TableHeader>
        <TableBody>
          {calls.map((call) => (
            <SadieVoiceCallRow key={call.id} call={call} />
          ))}
        </TableBody>
      </Table>
    </Column>
  );
};
